export const nameSpace = 'assets';
